import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { PRODUCT, comparisonRows } from '../data/poolContent';
export function ComparisonSection() {
  return <section className="w-full bg-abyss-900 py-14 sm:py-20" aria-labelledby="comparison-title" data-id="element-57" data-mp="3e7tucxhijvf7">
      <div className="mx-auto max-w-5xl px-5" data-id="element-58" data-mp="39codid2yx6xz">
        <h2 id="comparison-title" className="mx-auto max-w-3xl text-center font-display text-[2.1rem] font-bold uppercase leading-none text-frost-50 sm:text-[3rem]" data-id="element-59" data-mp="34gfzj30ibjse">
          What changes when you know what to do next
        </h2>

        <div className="mt-10 hidden grid-cols-[10rem_minmax(0,1fr)_minmax(0,1fr)] gap-x-6 border-b border-abyss-600 pb-3 text-[11px] font-semibold uppercase tracking-[0.18em] sm:grid" data-id="element-60" data-mp="2qfvh47yi7pzf">
          <span data-id="element-61" data-mp="2liwlfkz6zaz4" />
          <span className="text-muted" data-id="element-62" data-mp="ooib1fksvc1s">Without the system</span>
          <span className="text-aqua" data-id="element-63" data-mp="onqsp6g7ratg">With {PRODUCT}</span>
        </div>

        <ul className="mt-8 divide-y divide-abyss-600 border-y border-abyss-600 sm:mt-0 sm:border-t-0" data-id="element-64" data-mp="jqgw96uepyw4">
          {comparisonRows.map(row => <li key={row.aspect} className="grid gap-3 py-5 sm:grid-cols-[10rem_minmax(0,1fr)_minmax(0,1fr)] sm:items-center sm:gap-x-6" data-id="element-65" data-mp="3ahh2tda6t25k">
              <p className="font-display text-[1.2rem] font-bold uppercase leading-tight text-frost-50" data-id="element-66" data-mp="30irk5iagvdo9">
                {row.aspect}
              </p>
              <p className="flex items-start gap-2.5 text-[14px] leading-snug text-body" data-id="element-67" data-mp="3t52nh0pgjsor">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" strokeWidth={2.5} aria-hidden="true" data-id="element-68" data-mp="1zt0zj0o9wjw" />
                <span data-id="element-69" data-mp="3jgko8nwtttn8">
                  <span className="sr-only sm:hidden" data-id="element-70" data-mp="3jezuh0ic6eqf">Without: </span>
                  {row.without}
                </span>
              </p>
              <p className="flex items-start gap-2.5 rounded-lg bg-navy/60 px-3 py-2.5 text-[14px] font-medium leading-snug text-frost-50" data-id="element-71" data-mp="3ocj9w3qrsxjy">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua" strokeWidth={2.5} aria-hidden="true" data-id="element-72" data-mp="kquah0zf5ahp" />
                <span data-id="element-73" data-mp="ukgcwkpopw35">
                  <span className="sr-only sm:hidden" data-id="element-74" data-mp="ukzrpsk1g4cy">With the guide: </span>
                  {row.with}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}